export default "<div class=\"modal-body\">\n  <ng-content select=\"[content]\"></ng-content>\n</div>\n"